const isRecord = (value: unknown): value is Record<string, unknown> => Object.prototype.toString.call(value) === '[object Object]';

const extractMessage = (value: unknown, visited = new Set<object>()): string => {
  if (typeof value === 'string') return value.trim();
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  if (value && typeof value === 'object') {
    if (visited.has(value)) return '';
    visited.add(value);
  }
  if (Array.isArray(value))
    return value
      .map((item) => extractMessage(item, visited))
      .filter(Boolean)
      .join(', ');
  if (!isRecord(value)) return '';

  for (const key of ['message', 'error', 'detail', 'details', 'title']) {
    const message = extractMessage(value[key], visited);
    if (message) return message;
  }
  return '';
};

export const normalizeAxiosError = (error: any) => {
  if (!error || typeof error !== 'object') return error;

  const data = error?.response?.data;
  const message = extractMessage(data) || extractMessage(error.message) || 'Request failed';

  if (isRecord(data)) {
    const preserveRawMessage = 'message' in data && typeof data.message !== 'string';
    error.response.data = {
      ...data,
      ...(preserveRawMessage ? { rawMessage: data.message } : {}),
      message,
    };
  }

  error.message = message;
  return error;
};
